import React from "react";
import "./style/CardMeetingHistory.css";
import { Box, Button, Modal, Typography } from "@mui/material";
import Rating from '@mui/material/Rating';
import cutButton from "../Icons/Group 144.png";
import "../Investor/style/RescheduleMeetingReason.css";
import Backdrop from '@mui/material/Backdrop';
import { callApi } from "../../common/api";
import CustomizedSnackbars from "../alert/alert";

const CardMeetingHistory = ({ status, meeting, OpenReschedule, handleCancel }) => {
    const [value, setValue] = React.useState(1);
    const [open, setOpen] = React.useState(false);
    const [reviews, setReviews] = React.useState("");
    const [next, setNext] = React.useState(false);
    const [id, setId] = React.useState("");
    const [submittedReview, setSubmittedReview] = React.useState(null);
    const [snackBarMsg, setSnackBarMsg] = React.useState({
        message: "",
        severity: "success",
        open: false,
    });

    const getTime = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const dayOfWeek = daysOfWeek[inputDate.getDay()];
        const date = inputDate.getDate();
        const month = months[inputDate.getMonth()];
        const year = inputDate.getFullYear();
        const hours = inputDate.getHours().toString().padStart(2, '0');
        const minutes = inputDate.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = (hours % 12) || 12;
        const formattedTime = `${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
        const formattedDate = `${dayOfWeek}, ${date} ${month} ${year}`;
        return {
            formattedDate: formattedDate,
            formattedTime: formattedTime
        };
    };

    const review = (id) => {
        setOpen(true);
        setId(id);
    };

    const handleChange = (event) => {
        const value = event.target.value;
        setReviews(value);
    };

    const handleClose = () => {
        setReviews("");
        setNext(false);
        setOpen(false);
    };

    const handleNext = () => {
        if (reviews) {
            setNext(true);
        }
    };

    const handleReviews = async () => {
        if (reviews) {
            let obj = {
                id: id,
                review: reviews,
                rating: value
            };
            try {
                const response = await callApi("post", "investor/meetingReview", obj);
                if (response.data.response.status) {
                    setOpen(false);
                    setSubmittedReview({ review: reviews, rating: value });
                    setSnackBarMsg({
                        message: "Successfully registered",
                        severity: "success",
                        open: true,
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }
    };

    return (
        <Box id="card">
            <Box className="cardBox-1">
                <Typography style={{ color: status === "CANCELLED" ? "#F48E8E" : "#A2FBB3" }}>{status === "ACCEPTED" || status === "RESCHEDULED" ? "" : status}</Typography>
                <Typography className="time">on {getTime(status === "CANCELLED" ? meeting.cancelTime : meeting.createdAt).formattedDate} at {getTime(status === "CANCELLED" ? meeting.cancelTime : meeting.createdAt).formattedTime} as per your request</Typography>
            </Box>
            <Box className="cardBox-2">
                {status === "ACCEPTED" || status === "RESCHEDULED" || status === "SUCCESSFUL" || status === "PENDING" ?
                    <Typography>
                        The meeting scheduled for {getTime(meeting.meetingStart).formattedDate} at {getTime(meeting.meetingStart).formattedTime}, with {`${meeting.firstName} ${meeting.lastName}`} {status === "SUCCESSFUL" ? "was successfully completed from our side" : ""}.
                    </Typography>
                    :
                    <Typography>
                        The meeting scheduled for {getTime(meeting.meetingStart).formattedDate} at {getTime(meeting.meetingStart).formattedTime}, with {`${meeting.firstName} ${meeting.lastName}`} was cancelled from Your side due to {meeting?.reason !== "undefined" ? meeting?.reason : "Unforeseen Circumstances"}
                    </Typography>
                }
            </Box>
            {status === "CANCELLED" || status === "RESCHEDULED" || status === "ACCEPTED" || status === "PENDING" ?
                ""
                :
                <Box
                    sx={{
                        '& > legend': { mt: 2 },
                        '& .MuiRating-iconEmpty': {
                            color: 'white',
                        },
                        '& .MuiRating-iconHover': {
                            color: 'orange',
                        },
                    }}
                >
                    {/* <Rating
                        name="simple-controlled"
                        value={submittedReview ? submittedReview.rating : value}
                        onChange={(event, newValue) => {
                            if (!submittedReview) {
                                setValue(newValue);
                            }
                        }}
                        readOnly={!!submittedReview}
                    /> */}
                </Box>
            }

            {submittedReview && (
                <Box className="reviewBox">
                <Rating
                    name="read-only"
                    value={submittedReview.rating}
                    readOnly
                />
                    <Typography variant="body1">{submittedReview.review}</Typography>
                </Box>
            )}

            <Box className="button-group">
                {status === "SUCCESSFUL" ?
                    <Modal aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        closeAfterTransition
                        slots={{ backdrop: Backdrop }}
                        slotProps={{
                            backdrop: {
                                timeout: 500,
                            },
                        }} open={open} onClose={handleClose}>
                        <Box className="Frame427319323">
                            <Box className="Frame427319561">
                                <Box className="Frame427319556">
                                    <Box className="Frame427319502">
                                        {/* <Typography className="reason-heading">Write Review</Typography> */}
                                    </Box>
                                    <Button onClick={handleClose}>
                                        <img src={cutButton} alt="X" />
                                    </Button>
                                </Box>
                                <Box className="main-input">
                                    <Box className="label">
                                        <Typography className="reason-heading">Write Review</Typography>
                                        <Typography className="star">*</Typography>
                                    </Box>
                                    <Rating
                                        name="simple-controlled"
                                        value={submittedReview ? submittedReview.rating : value}
                                        onChange={(event, newValue) => {
                                            if (!submittedReview) {
                                                setValue(newValue);
                                            }
                                        }}
                                        readOnly={!!submittedReview}
                                    />
                                    <Box className="input">
                                        <Box className="inside-input-box">
                                            <textarea name="review" placeholder="Enter Review" onChange={handleChange} className="text-area"></textarea>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box className="Frame427319560">
                                <Button onClick={handleClose} className="resch-btn">
                                    <Typography className="resch-btn-text">Cancel</Typography>
                                </Button>
                                <Button onClick={handleReviews} sx={{ backgroundColor: "white", minWidth: "137px" }} className="resch-btn">
                                    <Typography sx={{ color: "black" }} className="resch-btn-text">Submit</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                    : ''}
                <Button onClick={status === "CANCELLED" || status === "RESCHEDULED" || status === "ACCEPTED" || status === "PENDING" ? () => OpenReschedule(status, meeting.id, meeting.startUpId, meeting.meetingId) : () => review(meeting.id)} className="rescheduleButton"><Typography className="btn-text">{status === "CANCELLED" || status === "RESCHEDULED" || status === "ACCEPTED" || status === "PENDING" ? "Reschedule meeting" : "Write Review"}</Typography></Button>
                {status === "RESCHEDULED" || status === "ACCEPTED" ? 
                    <Button onClick={() => handleCancel(meeting.meetingId)} className="rescheduleButton"><Typography className="btn-text">Cancel</Typography></Button> :
                    <></>
                }
            </Box>
            <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
        </Box>
    );
};

export default CardMeetingHistory;
